import { FaBuilding, FaPhone, FaEnvelope, FaExpand, FaPlug, FaMapMarkerAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";

import images from "./images";

const Venue = {
    googleMap: {
        src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d317716.6065440981!2d-0.4312527129418162!3d51.528606999961184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2s!4v1727192621929!5m2!1sen!2s",
        allowFullScreen: true,
        loading: "lazy"
    },
    venueInfo: {
        sub: "Explore Our Venue Details",
        heading: "Venue Information",
        points: [
            { icon: <FaBuilding />, title: "Venue Name", description: "The Grand Orchid Hotel" },
            { icon: <FaLocationDot />, title: "Venue Address", description: "123 Orchid Boulevard, 5th Avenue\nDowntown Blossom City\nNew York, NY 10001, USA" },
            { icon: <FaPhone />, title: "Contact Number", description: "+123-456-789\n+111-222-333" },
            { icon: <FaEnvelope />, title: "Email Address", description: "abc@gmail.com\nxyz@gmail.com" }
        ]
    },
    venueGallery: [
        images.venueGallery1,
        images.venueGallery2,
        images.venueGallery3,
    ],
    venueFeatures: [
        { icon: <FaExpand />, title: "Spacious Layout", description: "Experience a generously sized venue designed to enhance attendee comfort and engagement." },
        { icon: <FaPlug />, title: "Modern Amenities", description: "Enjoy state-of-the-art facilities, including high-speed Wi-Fi and audio-visual equipment." },
        { icon: <FaMapMarkerAlt />, title: "Prime Location", description: "Conveniently situated in the heart of the city, easily accessible by public transport." }
    ],
    hotelRooms: {
        sub: "We're Here to Help!",
        heading: "Book Your Hotel Room",
        rooms: [
            { src: images.venueRoom1, alt: "Standard Room", title: "Standard Room", price: "$90/per night" },
            { src: images.venueRoom2, alt: "Deluxe Room", title: "Deluxe Room", price: "$120/per night" },
            { src: images.venueRoom3, alt: "Executive Suite", title: "Executive Suite", price: "$180/per night" }
        ]
    }
};

export default Venue;